<template>
    <div class="dashboard_faculty_square_holder">
        <div class="dashboard_faculty_square_item">
            <div class="dashboard_faculty_item_left">
                <div class="as_link_grey dashboard_faculty_item_name"
                    @click="changeFacultySection({ data: { section_id: section_data.id } })">
                    {{ section_data.name }}
                </div>
                <br><br>
                <div class="deadline_status" :class="deadlineStatus">{{ status_text }}</div>
                <div class="dashboard_faculty_item_progress">
                    Oddano: {{ faculty_submitted_count }} / {{ faculty_count }}
                </div>
                <br><br><br>
                <div v-show="deadlineTimestamp > 0" class="dashboard_faculty_square_item_deadline">
                    Rok: {{ getDeadline() }}
                </div><br>
                <div v-show="deadlineClosedTimestamp > 0" class="dashboard_faculty_square_item_deadline">
                    Zadnji rok: {{ getDeadlineClosed() }}
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapActions } from 'vuex';

export default {
    name: 'SectionsDashboardSectionSquareItem',
    data() {
        return {
            deadlineTimestamp: 0,
            deadlineClosedTimestamp: 0,
            status_text: '',
            nearDeadlineDays: 14
        };
    },
    props: {
        section_data: Object,
        faculty_submitted_count: Number,
        faculty_count: Number
    },
    computed: {
        deadlineStatus() {
            const now = Date.now();

            if (this.faculty_submitted_count === this.faculty_count && this.faculty_count > 0) return 'filled';
            if (this.deadlineClosedTimestamp > 0 && now > this.deadlineClosedTimestamp) return 'after_late';
            if (this.deadlineTimestamp > 0) {
                if (now > this.deadlineTimestamp) return 'after';
                if (now > this.deadlineTimestamp - this.nearDeadlineDays * 86400000) return 'preparation_late';
            }
            return 'preparation';
        }
    },
    watch: {
        deadlineStatus: {
            immediate: true,
            handler(newVal) {
                if (!this.section_data?.id) return;

                this.status_text = {
                    filled: 'oddano',
                    after_late: 'zamujeno',
                    after: 'zamuda',
                    preparation_late: 'v pripravi',
                    preparation: 'v pripravi'
                }[newVal];

                this.dashboardAddLastStatusBySection({
                    id: this.section_data.id,
                    status: 'status_' + newVal
                });
            }
        }
    },
    mounted() {
        this.deadlineTimestamp = this.getTS(this.section_data.deadline);
        this.deadlineClosedTimestamp = this.getTS(this.section_data.deadlineClosed);
    },
    methods: {
        ...mapActions(['changeFacultySection','changeFaculty','dashboardAddLastStatusBySection']),
        getTS(dateStr) {
            if (!dateStr || dateStr === '0000-00-00') return 0;
            return new Date(dateStr).getTime();
        },
        getDeadline() {
            if (!this.section_data?.deadline || this.section_data.deadline === '0000-00-00') return '';
            const date = new Date(this.section_data.deadline);
            this.deadlineTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },

        getDeadlineClosed() {
            if (!this.section_data?.deadlineClosed || this.section_data.deadlineClosed === '0000-00-00') return '';
            const date = new Date(this.section_data.deadlineClosed);
            this.deadlineClosedTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        }
    }
};
</script>

<style lang="scss" scoped></style>
